import { createCustomEnum } from "./customEnum";

const BackEndPlatformTypes = createCustomEnum({
	Omaha: {
		value: 1,
		name: "omaha",
		displayName: "Omaha",
	},
	North: {
		value: 2,
		name: "north",
		displayName: "North",
	},
	Tsys: {
		value: 3,
		name: "tsys",
		displayName: "TSYS",
	},
	Other: {
		value: 4,
		name: "other",
		displayName: "Other",
	},
	Straddle: {
		value: 3,
		name: "straddle",
		displayName: "Straddle",
	},
});

export default BackEndPlatformTypes;
